import { Expose, Type } from 'class-transformer';
import { CommonModel } from 'common/repositories/common.model';

// Model

export class TipLiteModel extends CommonModel {
  description: string;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt?: Date;

  @Expose({ name: 'account_type' })
  accountType: string;

  @Type(() => Number)
  amount: number;
}

// Input

export class getTipsInput {
  id: string;
  params: {
    page: number;
    limit?: number;
  };
}

export class TipMutationInput {
  transactionAt?: Date | null;
  amount: number;
  description: string;
}

export class TipCreateInput {
  saleId: string;
  body: { tips: TipMutationInput[] };
}

export class TipUpdateInput {
  tipId: string;
  body: TipMutationInput;
}

export class TipDeleteInput {
  tipId: string;
}
